import { withInstall } from "@xplus/utils/with-install";
import badge from "./src/badge.vue";
export const xBadge = withInstall(badge);
export default xBadge;
